<template>
  <div>
    <div class="name-block">
      <div class="name">{{ candidateName }}</div>

      <div
        v-tooltip="$tr('bcg-test.responses.actions.testExportXls')"
        class="name-block__xls-export"
        @click="exportXlsTest(`/v3/responses/${responseId}/report?modules[]=test`, 'response-test.xlsx')"
      >
        <i class="icon icon-excel"></i>
      </div>

      <div class="cv-row">
        <a
          v-if="resumeLinkFile"
          v-tooltip="{
            content: resumeLinkFile,
            placement: 'right',
            classes: 'cv-tooltip'
          }"
          class="cv-row-resume-link"
          :href="resumeLinkFile"
          target="_blank"
          rel="noopener"
        >
          <svg class="cv-row-icon">
            <use xlink:href="/static/icons/cv-icons.svg#file" />
          </svg>
        </a>
        <a
          v-if="resumeLinkUrl"
          v-tooltip="{
            content: resumeLinkUrl,
            placement: 'right',
            classes: 'cv-tooltip'
          }"
          class="cv-row-resume-link"
          :href="resumeLinkUrl"
          target="_blank"
          rel="noopener"
        >
          <svg class="cv-row-icon">
            <use xlink:href="/static/icons/cv-icons.svg#url" />
          </svg>
        </a>
      </div>

      <div class="stars">
        <span v-for="(star, index) in [1, 2, 3, 4, 5]" :key="index" :class="{ empty: starRating < star }">
          <i class="fa fa-star" @click="setStars(star)"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'BlockName',

  props: {
    candidateName: {
      type: String,
      default: ''
    },

    starRating: {
      type: Number,
      default: 0
    },

    setStars: {
      type: Function,
      default: star => {}
    },

    resumeLinkFile: {
      type: String,
      default: ''
    },

    resumeLinkUrl: {
      type: String,
      default: ''
    },

    responseId: {
      type: String,
      default: ''
    }
  },

  methods: {
    exportXlsTest(url, name) {
      Axios.get(url, { responseType: 'arraybuffer' })
        .then(response => {
          let blob = new Blob([response.data], { type: response.headers['content-type'] });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = name;
          link.click();
        })
        .catch(() => {
          this.$noty.error(this.$tr('vacancy.preferences.modals.saveFailure.text'));
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.name-block {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__xls-export {
    font-size: 22px;
    cursor: pointer;
    color: $grey-darker;
    transition: color 0.3s;

    &:hover {
      color: $green-hover;
      transition: color 0.3s;
    }
  }

  .name {
    // font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 41px;
    color: #233346;
    max-width: 470px;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 16px;
  }

  .name + a {
    margin-left: 6px;
    display: flex;
    align-items: center;
  }

  .stars {
    display: flex;
    align-items: center;
    height: 24px;
    margin-left: 14px;
    min-width: 130px;
    position: relative;
    span {
      cursor: pointer;
      line-height: 24px;
      font-size: 17px;
      color: $green;
      margin-right: 1px;

      &.empty {
        color: $inner-navigation-background-color;
      }

      &:hover {
        color: $green-hover;
      }
    }
  }
}
</style>
